import { useSelector } from "react-redux"
import styled from "styled-components"
import InputText from "../../shared/input/new/InputText"
import InputSelect from "../../shared/input/new/InputSelect"
import { useEffect, useState } from "react"
import MessageFileInput from "../../shared/input/special/MessageFileInput"
import Btn from "../../shared/button/Btn"
import { createBlog } from "../../../features/admin3/admin3Slice"
import { useDispatch } from "react-redux"
import TopMenus from "../../shared/TopMenus"
import cn from "classnames"


const Container = styled.div`
    height: 100%;
    width: 100%;
    
    .blog-container{
        height: calc(100% - 120px);
        width: 100%;
        max-height: 4000px !important;
        overflow: auto;
        padding: 25px;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 20px;
        .img-container{
            display: flex;
            align-items: center;
            gap: 20px;
        }
        .col{
            display: flex;
            flex-direction: column;
            gap: 5px;
            .info{
                font-size: var(--font-size-xs);
                font-weight: var(--font-weight-md);
                color: ${({ theme }) => theme.mainTextColor} !important;
            }
            .alert{
                font-size: var(--font-size-xs);
                font-weight: var(--font-weight-md);
                color: var(--color-main) !important;
            }
            .error{
                font-size: var(--font-size-xs);
                font-weight: var(--font-weight-md);
                color: var(--color-main) !important;
            }
        }
        
    }

`

const tabData = [
    {
        id: 1,
        text: "Kamyonculara Özel",
        value: "ozel"
    },
    {
        id: 2,
        text: "Sektörden Haberler",
        value: "sektor"
    },
    {
        id: 3,
        text: "Güncel",
        value: "guncel"
    },
    {
        id: 4,
        text: "Nakliye Yönetim Sistemi TMS",
        value: "tms"
    }
]

const NewBlogMainSide = () => {
    const dispatch = useDispatch()
    const [listAndDetailImage, setListAndDetailImage] = useState(null)
    const [metaTitleLength, setMetaTitleLength] = useState("")
    const [metaDescLength, setMetaDescLength] = useState("")
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [tabName, setTabName] = useState(null)
    const [listData, setListData] = useState({
        metaTitle: "",
        metaDescription: "",
        slug: "",
        alt:"",
        text: "",
        shortDesc: "",
        tabName: "",
        ticket: ""
    })

    const handleChange = (e) => {
        setListData({...listData, [e.target.name]: e.target.value})
    }

    const handleCreateBlogList = () => {
        setIsSubmitting(true)
        if(listData.metaTitle && listData.metaDescription && listData.slug && listData.alt && listData.text && listData.shortDesc && tabName && listAndDetailImage){
            const formData = new FormData()
            formData.append("metaTitle", listData.metaTitle)
            formData.append("metadescription", listData.metaDescription)
            formData.append("slug", listData.slug)
            formData.append("alt", listData.alt)
            formData.append("text", listData.text)
            formData.append("shortDesc", listData.shortDesc)
            formData.append("tabName", tabName.value)
            formData.append("ticket", tabName.text)
            formData.append("image", listAndDetailImage)
            dispatch(createBlog(formData))

            setListData({
                metaTitle: "",
                metaDescription: "",
                slug: "",
                alt:"",
                text: "",
                shortDesc: "",
                tabName: "",
                ticket: ""
            })
            setTabName(null)
            setListAndDetailImage(null)
            setMetaTitleLength("")
            setMetaDescLength("")
            setIsSubmitting(false)
        }
    }

    useEffect(() => {
        setMetaTitleLength(listData.metaTitle?.length)
        setMetaDescLength(listData.metaDescription?.length)
    }, [listData.metaDescription, listData.metaTitle])

  return (

    <Container>

        <div className="blog-container">
            <div className="col">
                <InputText inputWidth={"100%"} data={listData.metaTitle} setData={(e) => handleChange(e)} name={"metaTitle"} labelText={"Meta Title"} />
                <p className={cn(metaTitleLength >= 60 ? "alert" : "info")}>
                    ({metaTitleLength} Karakter)
                </p>
                {isSubmitting && !listData.metaTitle && 
                    <p className="error">Zorunlu alan!</p>
                }
            </div>
            
            <div className="col">
                <InputText inputWidth={"100%"} data={listData.metaDescription} setData={(e) => handleChange(e)} name={"metaDescription"} labelText={"Meta Description"} />
                <p className={cn(metaDescLength >= 160 ? "alert" : "info")}>
                    ({metaDescLength} Karakter)
                </p>
                {isSubmitting && !listData.metaDescription && 
                    <p className="error">Zorunlu alan!</p>
                }
            </div>
            <div className="col">
                <InputText inputWidth={"100%"} data={listData.slug} setData={(e) => handleChange(e)} name={"slug"} labelText={"Sayfa Uzantısı"} />
                {isSubmitting && !listData.slug && 
                    <p className="error">Zorunlu alan!</p>
                }
            </div>
            <div className="col">
                <div className="img-container">
                    <MessageFileInput setSelectedFile={setListAndDetailImage} />
                    <InputText inputWidth={"100%"} data={listAndDetailImage?.name} disabled={true} setData={(e) => handleChange(e)} name={"listAndDetailImage"} labelText={"Bloglar Listesi Görseli ve Detay Sayfası Ana Görsel"} />
                </div>
                {isSubmitting && !listAndDetailImage && 
                    <p className="error">Zorunlu alan!</p>
                }
            </div>
            
            <div className="col">
                <InputText inputWidth={"100%"} data={listData.alt} setData={(e) => handleChange(e)} name={"alt"} labelText={"Liste ve Detay Banner Alt Etiketi"} />
                {isSubmitting && !listData.alt && 
                    <p className="error">Zorunlu alan!</p>
                }
            </div>
            <div className="col">
                <InputText inputWidth={"100%"} data={listData.text} setData={(e) => handleChange(e)} name={"text"} labelText={"Blog Listesindeki Başlık (Başlık uzun ise <br/> ile başlığı iki satır yapın!)"} />
                {isSubmitting && !listData.text && 
                    <p className="error">Zorunlu alan!</p>
                }
            </div>
            <div className="col">
                <InputText inputWidth={"100%"} data={listData.shortDesc} setData={(e) => handleChange(e)} name={"shortDesc"} labelText={"Kısa Açıklama"} />
                {isSubmitting && !listData.shortDesc && 
                    <p className="error">Zorunlu alan!</p>
                }
            </div>
            <div className="col">
                <InputSelect initialOptions={tabData} inputWidth={"100%"} data={tabName?.text || ""} setData={setTabName} name={"text"} labelText={"İçerik Kategorisi"} />
                {isSubmitting && !tabName && 
                    <p className="error">Zorunlu alan!</p>
                }
            </div>
            <div className="btn-container">
                <Btn width={"200px"} color="#E85446" bgColor="transparent" padding="0 10px" handleClick={handleCreateBlogList} >Ekle</Btn>
            </div>
        </div>
         
    </Container>
  )
}

export default NewBlogMainSide